<template>
    <div class="fade-in">
        <div
            v-for="(item, index) in families"
            :key="item.uuid || index"
            class="border border-light rounded mb-3 overflow-hidden"
        >
            <div class="bg-light px-3 py-2">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h6 class="font-weight-bold mb-1">{{ item.name || '--' }}</h6>
                    </div>
                    <span
                        v-if="item.isEmergency"
                        class="badge badge-danger ml-2 flex-shrink-0"
                    >
                        Emergency
                    </span>
                </div>
            </div>
            <div class="p-3">
                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted d-block">Relationship</small>
                        <div class="font-weight-bold">{{ item.relationship }}</div>
                    </div>
                    <div class="col-md-4">
                        <small class="text-muted d-block">Occupation</small>
                        <div class="font-weight-bold">{{ item.occupation || '--' }}</div>
                    </div>
                    <div class="col-md-4">
                        <small class="text-muted d-block">Phone</small>
                        <div class="font-weight-bold">{{ phoneNumber(item) }}</div>
                    </div>
                    <div class="col-12 mt-3">
                        <small class="text-muted d-block">Address</small>
                        <div class="font-weight-bold" style="white-space: pre-line;">{{ item.address || '--' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <b-alert
            v-if="!families || families.length == 0"
            show
            variant="warning"
            class="text-center"
        >
            <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
        </b-alert>
    </div>
</template>
<script>
export default {
    props: {
        families: {
            type: Array,
            required: true,
        },
    },
    methods: {
        phoneNumber(data) {
            if (data.phoneCode && data.phoneNumber) return `${data.phoneCode} ${data.phoneNumber}`;
            if (data.phoneNumber) return data.phoneNumber;
            return '--';
        },
    },
}
</script>
